import { StoreApi } from 'zustand';

import { TTextLocalized } from '@northladder/utilities';

// TODO: Merge apis/GradeReviewStatus and services/IGradeStatus enum/
export enum IGradeStatus {
  DISPUTE_ADJUSTED = 'DISPUTE_ADJUSTED',
  UNDER_PROCESS = 'UNDER_PROCESS',
  GRADE_REVISED = 'GRADE_REVISED',
  GRADE_UNCHANGED = 'GRADE_UNCHANGED',
  ADDITIONAL_INFO_REQUIRED = 'ADDITIONAL_INFO_REQUIRED',
  REQUESTED_TO_RETURN = 'REQUESTED_TO_RETURN',
  RETURN_IN_PROGRESS = 'RETURN_IN_PROGRESS',
  DEVICE_RETURNED = 'DEVICE_RETURNED',
  // TODO: Currently it will not be used, inside this enum will change after sometime.
  // TODO: May be we need to remove this entire enum to change it something reusable
  // TODO:  otherwise the Grade card will not be reusable. `cc: @Sowed, @Yaten`
  DEVICE_DELIVERED = 'DELIVERED',
  NONE = 'NONE',
}

/**
 * Interface for filter options for subtitle of grade review request list.
 */
export interface IGradeFilterOptionsWithSubtitle {
  isCritical: boolean;
  value: TTextLocalized;
}

/**
 * Interface to format the grade review request list response.
 */
export interface IGradeReviewScreenFilterOptions {
  count: number;
  label: TTextLocalized;
  subtitle: IGradeFilterOptionsWithSubtitle;
  value: keyof typeof IGradeStatus;
}

export interface IDateRange {
  endDate: string | null;
  startDate: string | null;
}

export interface IGradeReviewListFilterState {
  /**
   * clears all grade filter.
   */
  clearGradeReviewListFilterStore: () => void;
  /**
   * Date range filter for grade review requests
   */
  dateRange: IDateRange | null;
  /**
   * Column visibility state for grade review requests list table
   */
  grrListColumns: Record<string, boolean>;
  /**
   * Page size for grade review requests list table
   */
  grrListPageSize: number;
  /**
   * To update date range filter
   */
  onUpdateGradeReviewDateRange: (dateRange: IDateRange | null) => void;
  /**
   * list of active filters
   */
  selectedGradeFilters: IGradeReviewScreenFilterOptions[];
  /**
   * Update column visibility state for grade review requests list table
   */
  updateGrrListColumns: (visibility: Record<string, boolean>) => void;
  /**
   * Update page size for grade review requests list table
   */
  updateGrrListPageSize: (pageSize: number) => void;
  /**
   * Selected Grade Review Request status filter.
   */
  selectedStatuses: string[];
  /**
   * To update the selected statuses for grade review requests list table.
   */
  onUpdateSelectedStatuses: (statuses: string[]) => void;
  /**
   * To update `selectedGradeFilters`
   */
  updateSelectedGradeFilters: (
    filters: IGradeReviewScreenFilterOptions[]
  ) => void;
}

export type TSetGradeReviewListFilters =
  StoreApi<IGradeReviewListFilterState>['setState'];
